// extracted by css-extract-rspack-plugin
export default {"rule":"rule-W25BpD"};